import { Badge } from '@radix-ui/themes';
import { BuildPriority } from 'lib_ts/enums/pitches.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const PitchPriorityBadge = (props: {
  value: BuildPriority | undefined;
}) => {
  return (
    <Badge color={RADIX.COLOR.NEUTRAL}>
      {props.value === BuildPriority.Breaks ? 'Break' : 'Spin'}
    </Badge>
  );
};
